
import startCase from "lodash.startcase";

export default {
  name: "Tags",
  scrollToTop: true,
  async asyncData({ $content, params, error }) {
    const tags = await $content("tags")
      .sortBy("date", "desc")
      .fetch()
      .catch(() => {
        error({ statusCode: 404, message: "no tags found" });
      });

    return {
      tags,
    };
  },
  head() {
    return {
      title: "Tags",
      titleTemplate: "%s | INDOMASCOT",
      url: "https://www.indomascot.com/tag/",
      description:
        "INDOMASCOT selalu mempersembahkan berita-berita seputar kostum badut maskot yang bermanfaat untuk anda",
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
      ],
    };
  },
  created() {
    this.startCase = startCase;
  },
};
